var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRefreshIcon = function SvgRefreshIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.197 1.86a7.297 7.297 0 0 1 6.221-.308.848.848 0 1 1-.648 1.567A5.601 5.601 0 0 0 5 3.352C2.934 4.465 2.026 6.655 2.568 8.66a.848.848 0 0 1 1.566.627l-.522 1.816a.848.848 0 0 1-1.02.589l-1.95-.487a.848.848 0 0 1 .411-1.645l.02.005c-1.036-2.896.232-6.149 3.124-7.705Zm7.452 2.037a.848.848 0 0 1 1.02-.588l1.95.487a.848.848 0 0 1-.411 1.645l-.02-.005c1.036 2.896-.231 6.149-3.123 7.705a7.297 7.297 0 0 1-6.222.307.848.848 0 1 1 .648-1.567c1.488.615 3.26.58 4.77-.233 2.066-1.112 2.974-3.303 2.432-5.307a.848.848 0 0 1-1.566-.627l.522-1.817Z",
    fill: "currentColor"
  })));
};

export default SvgRefreshIcon;